import React from "react";

const Skeleton = () => {
  return (
    <div
      id="jobDetailContainer"
      className="bg-surface-primary-normal md:!border-border-subtle w-full animate-pulse md:!rounded-2xl md:!border md:!border-solid"
    >
      <div className="bg-jdPage-gradient relative flex min-h-[94px] px-6 py-4 md:!rounded-t-2xl">
        <div className="border-surface-primary-disabled absolute left-4 top-[45px] flex size-[70px] items-center justify-center rounded border border-solid bg-gray-200 p-px md:!left-[30px] md:!top-[50px]"></div>
      </div>
      <div className="p-4 md:!mt-2 md:!p-6">
        <div className="mt-4 h-6 max-w-[60%] rounded-full bg-gray-200"></div>

        {/* tags */}
        <div className="mt-3 flex gap-2 md:!mt-6">
          <div className="h-6 w-[25%] rounded-md bg-gray-200 md:w-[10%]"></div>
          <div className="h-6 w-[25%] rounded-md bg-gray-200 md:w-[10%]"></div>
        </div>

        {/* location info */}
        <div className="mt-3 flex flex-col gap-2 md:!mt-6">
          <div className="h-4 w-[40%] rounded-md bg-gray-200 md:w-[25%]"></div>
          <div className="h-4 w-[60%] rounded-md bg-gray-200 md:w-[35%]"></div>
          <div className="h-4 w-[55%] rounded-md bg-gray-200 md:w-[20%]"></div>
        </div>

        {/* description */}
        <div className="mt-3 h-6 w-[25%] rounded-md bg-gray-200 md:!mt-8"></div>
        <div className="mt-2 flex flex-col gap-2 md:!mt-6">
          <div className="h-4 rounded-md bg-gray-200 md:w-[28%]"></div>
          <div className="h-4 rounded-md bg-gray-200 md:w-[35%]"></div>
          <div className="h-4 rounded-md bg-gray-200 md:w-[30%]"></div>
          <div className="h-4 rounded-md bg-gray-200 md:w-[60%]"></div>
          <div className="h-4 rounded-md bg-gray-200 md:w-[46%]"></div>
        </div>

        {/* more info */}
        <div className="mt-3 h-5 w-[25%] rounded-md bg-gray-200 md:!mt-8"></div>
        <div className="mt-2 flex flex-col gap-2 md:!mt-4">
          <div className="h-4 w-[60%] rounded-md bg-gray-200 md:w-[28%]"></div>
          <div className="h-4 w-[50%] rounded-md bg-gray-200 md:w-[35%]"></div>
        </div>

        {/* skills required */}
        <div className="mt-3 h-5 w-[25%] rounded-md bg-gray-200 md:!mt-8"></div>
        <div className="mt-3 flex gap-2 md:!mt-4">
          <div className="h-6 w-[30%] rounded-full bg-gray-200 md:w-[12%]"></div>
          <div className="h-6 w-[30%] rounded-full bg-gray-200 md:w-[12%]"></div>
          <div className="h-6 w-[30%] rounded-full bg-gray-200 md:w-[12%]"></div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
